"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuList = void 0;
var react_1 = __importDefault(require("react"));
var react_select_1 = require("react-select");
/**
 * A custom MenuList component for react-select that renders a custom banner
 * component. MenuList is the inner wrapper for the dropdown menu. It directly
 * wraps around the returned options. Does not show banner when loading.
 * @param {Object=} banner - Custom banner appearing after the select options
 */
var MenuList = function (props) {
    var _a;
    return (react_1.default.createElement(react_select_1.components.MenuList, __assign({}, props),
        props.children,
        !((_a = props.selectProps) === null || _a === void 0 ? void 0 : _a.isLoading) && props.banner));
};
exports.MenuList = MenuList;
